// TS 3.7's lib typings predate Promise.allSettled and its PromiseSettledResult types
// (ES2020), so we declare a minimal equivalent shape here rather than relying on lib types.
type SettledResult<T> =
    | { status: 'fulfilled'; value: T }
    | { status: 'rejected'; reason: any };

// Promise.allSettled isn't guaranteed at runtime on this app's browserslist target either
// (CRA/Babel only polyfills syntax, not runtime APIs) — use the native implementation when
// present, otherwise fall back to an equivalent built on Promise.all.
const settleAll = <T,>(promises: Promise<T>[]): Promise<SettledResult<T>[]> => {
    if (typeof (Promise as any).allSettled === 'function') {
        return (Promise as any).allSettled(promises);
    }
    return Promise.all(
        promises.map((p) =>
            p.then(
                (value): SettledResult<T> => ({ status: 'fulfilled', value }),
                (reason): SettledResult<T> => ({ status: 'rejected', reason }),
            ),
        ),
    );
};

export default settleAll;
